import React,{ useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import UploadProduct from './components/UploadProduct';
import Error from './components/404';
import Dashboard from './components/Dashboard';
import AdminLogin from './components/AdminLogin';
import { useStateValue } from './components/StateProvider';
import { auth } from "./firebase";
import AdminHeader from './components/AdminHeader';
import AllProducts from './components/AllProducts';
import ProductDetail from './components/ProductDetail';
import AdminFooter from './components/AdminFooter';
import AllCustomers from './components/AllCustomers';
import AllOrder from './components/AllOrder';
import { useHistory } from "react-router-dom";

function App() {
 const [{ user }, dispatch] = useStateValue();
 const history = useHistory();

   useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(authUser => {
      console.log('The User is >>>', authUser);

      if (authUser) {
        dispatch({
          type: 'SET_USER',
          user: authUser,
        });
      } else {
        dispatch({
          type: 'SET_USER',
          user: null,
        });
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return (
    <Router>
    <div className="App">
      <Switch>
   
   <Route path="/admin-login">
      <AdminHeader />
        <br /><br /><br /><br /><br />
      <AdminLogin />
        <br />
      <AdminFooter />
     </Route>
   
   <Route path="/orders">
      <AdminHeader />
        <br /><br /><br /><br /><br />
      <AllOrder />
      <br />
      <AdminFooter />
      </Route>

      <Route path="/customers">
    <AdminHeader />
    <br /><br /><br /><br /><br />
    <AllCustomers />
    <br />
    <AdminFooter />
     </Route>


      <Route path="/product-detail/:title">
          <AdminHeader />
          <br /><br /><br /><br />
          <ProductDetail />
          <AdminFooter />
        </Route>

     <Route path="/products">
      <AdminHeader />
        <br /><br /><br /><br /><br />
      <AllProducts />
       <br />
      <AdminFooter />
     </Route>

     <Route path="/dashboard">
      <AdminHeader />
        <br /><br /><br /><br /><br />
      <Dashboard />
        <br />
      <AdminFooter />
     </Route>

     <Route path="/upload-product">
      <AdminHeader />
        <br /><br /><br /><br /><br />
      <UploadProduct />
        <br />
      <AdminFooter />
     </Route>

    <Route path="/*">
        <AdminHeader />
         <br /><br /><br /><br /><br />
        <Error />
         <br />
        <AdminFooter />
      </Route>
      </Switch>
    </div>
    </Router>
  );
}

export default App;
